import memoize, { memoizeClear } from "@-/com.npmjs.memoize";
import { makeMutable, type SharedValue } from "@-/com.npmjs.react-native-reanimated";

/**
 * Where the Learn map draws its whole mainland when it first opens, in window coordinates (dp):
 * the map's top-left corner and its scale in points per map unit (the map is 1000 units wide).
 */
export type OnboardingMapFrame = { scale: number; x: number; y: number };

interface OnboardingHandoffState {
  mapFrame: SharedValue<OnboardingMapFrame | null>;
}

// Memoized rather than a top-level `let`, so tests can reset it with `memoizeClear`.
const getOnboardingHandoffState = memoize((): OnboardingHandoffState => ({
  mapFrame: makeMutable<OnboardingMapFrame | null>(null),
}));

/**
 * The Learn map's silhouette reports where it frames the mainland, whenever it is laid out, so the
 * onboarding's globe can land China exactly on it. `null` once it has gone.
 */
export function publishOnboardingMapFrame(frame: OnboardingMapFrame | null): void {
  getOnboardingHandoffState().mapFrame.set(frame);
}

/** Where the map last said its mainland rests; `null` until it has said. */
export function onboardingMapFrame(): SharedValue<OnboardingMapFrame | null> {
  return getOnboardingHandoffState().mapFrame;
}

/** Test-only: forget the reported frame. */
export function resetOnboardingHandoffForTests(): void {
  memoizeClear(getOnboardingHandoffState);
}
